import Vue from 'vue'
import Router from 'vue-router'
import HomeIndex from '@/views/home'
import wechatAuth from '@/utils/wechatAuth'
import store from '../store'
import { getOpenidByCode } from "../api/wechat";
import { wechatCodeLogin } from "../api/user";
import { getCookie, setCookie } from "@/utils/cookieUtils";

Vue.use(Router)

export const constantRouterMap = [
  {
    path: '/',
    component: HomeIndex,
    children: [
      { path: '/', component: () => import('@/views/index') },
      { path: '/about', component: () => import('@/views/about') },
      { path: '/life', component: () => import('@/views/life') },
      { path: '/list', component: () => import('@/views/list') },
      { path: '/sort', component: () => import('@/views/sort') },
      { path: '/share', component: () => import('@/views/share') },
      { path: '/subject', component: () => import('@/views/special') },
      // { path: '/subject2', component: () => import('@/views/special') },
      {
        path: '/subject/:subjectUid',
        component: () => import('@/views/specialDetail')
      },
      { path: '/time', component: () => import('@/views/time') },
      { path: '/rank', component: () => import('@/views/rank') },
      {
        path: '/info/:blogOid',
        component: () => import('@/views/info')
      },
      { path: '/messageBoard', component: () => import('@/views/messageBoard') },
      { path: '/question', component: () => import('@/views/question') },
      {
        path: '/qInfo/:questionOid',
        component: () => import('@/views/questionInfo')
      },
      { path: '/code', component: () => import('@/views/code') },
      {
        path: '/cInfo/:problemUid',
        component: () => import('@/views/codeInfo')
      },
      { path: '/userCenter', component: () => import('@/views/userCenter') },
      { path: '/notice', component: () => import('@/views/notice') },
      { path: '/moment', component: () => import('@/views/moment') },
      // { path: '/chat2', component: () => import('@/views/chat') },
      { path: '/chat', component: () => import('@/views/chatRoom') },
      { path: '/media', component: () => import('@/views/mediaInfoList') },
      { path: '/video/:videoId?', component: () => import('@/views/mediaVideo') },
      { path: '/hot', component: () => import('@/views/hot') },
      { path: '/resource', component: () => import('@/views/resource') },
      { path: '/resource/:resourceUid', component: () => import('@/views/resourceDetail') },
      { path: '/medal/:userUid', component: () => import('@/views/medal') },
      { path: '/sponsor', component: () => import('@/views/sponsor') },
      { path: '/lucky', component: () => import('@/views/lucky') },
      { path: '/giftLog', component: () => import('@/views/giftLog') },
    ]
  },
  { path: '/404', component: () => import('@/views/404') },
  { path: '/403', component: () => import('@/views/403') },
  { path: '/500', component: () => import('@/views/500') },
  { path: '/502', component: () => import('@/views/502') },
  { path: '/*', component: () => import('@/views/404') }

]

const router = new Router({
  mode: 'history',
  routes: constantRouterMap
})

//截取code
function getCode() {
  var code = "";
  let lets = {};
  let url = window.location.href;
  url = decodeURI(url)
  url.replace(
    /[?&]+([^=&]+)=([^&#]*)/gi,
    function (m, key, value) {
      lets[key] = value;
    }
  );
  if (lets["code"]) {
    code = lets["code"]
  }
  return code;
}

// 获取sign
function getSign(next) {
  let theCode = getCode();
  let appid = getCookie("appid")
  if (appid || appid != wechatAuth.appid) {
    setCookie("appid", wechatAuth.appid, 31)
  }
  if (theCode) {
    let params = {}
    params.code = theCode;
    params.appid = wechatAuth.appid;
    let realUrl = window.location.href;
    getOpenidByCode(params).then(response => {
      if (response.code == "success") {
        params.openid = response.data
        setCookie("openid", response.data, 31)
        wechatCodeLogin(params).then(res => {
          // localStorage.setItem("wx_sign", response.data);
          setCookie("token", res.data, 31)
          window.location.href = realUrl+ "?token=" + res.data;
          next()
        })
      } else {
        this.$message.error(response.message)
        WeixinJSBridge.call('closeWindow')
        window.location.href = realUrl;
        next()
      }
    })
  } else if (!store.state.user.isLogin ) {
    wechatAuth.redirectUri = window.location.href
    window.location.href = wechatAuth.authUrl
  } else {
    next()
  }
}

router.beforeEach((to, from, next) => {
  //是否是微信浏览器
  // if (/(micromessenger)/i.test(navigator.userAgent)) { 
  //   //是否电脑微信或者微信开发者工具
  //   if(/(WindowsWechat)/i.test(navigator.userAgent) || /(wechatdevtools)/i.test(navigator.userAgent)){
  //     alert('电脑微信或者微信开发者工具')
  //   }else{
  //     //手机微信打开的浏览器
  //     alert('手机微信')
  //   }
  // } else {
  //   alert('其他浏览器')
  // }
  let token = getCookie("token")
  if (/(micromessenger)/i.test(navigator.userAgent) && !token) {
    window.document.title = "自动登录中";
    getSign(next)
  } else {
    next();
  }
});

// router.beforeEach((to, from, next) => {
//   console.log("获取路径", to, from)
//   console.log("------------")
//   console.log(store.state.app.webNavbarList)
//   next()
// })

export default router
